import { render, staticRenderFns } from "./cl-address_book.vue?vue&type=template&id=738ae06c&scoped=true"
import script from "./cl-address_book.vue?vue&type=script&lang=js"
export * from "./cl-address_book.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ae06c",
  null
  
)

export default component.exports